<template>
  <div class="form-box">
    <el-form :model="formData" label-width="70px">
      <FormItemComp :formState="root"/>
    </el-form>
  </div>
</template>

<script>
import FormItemComp from '@/views/marketingManagement/configuration/formItemComp.vue'
import { createFormItemFactory } from './create.js'
import { displayType,appList,materialType,placementType,searchConfigData  } from './mock.js'
export default {
    components: { FormItemComp },
    inject: [ 'global'],
    data() {
        return {
            formData: {},
        }
    },
    computed: {
      root() {
        return  createFormItemFactory({ 
          displayType: this.global.displayTypeList,appList: this.global.appNumList,
          vm: this,
        })
      }
    },
}
</script>

<style lang="scss" scoped>

</style>